import { useCallback, useMemo } from 'react';
import moment from 'moment-timezone';
import { DATE_TIMEZONE_FORMAT } from '@constants/index';
import { useSelector } from 'react-redux';
import { getMainPageSlice } from '@store/features/filters/MainPageSlice/MainPageSlice';

export const useTimezone = () => {
  const { timeZone, customUTC, rigUTC } = useSelector(getMainPageSlice);

  const selectedTimeZone = useMemo(() => {
    return timeZone === 'CustomTimeZone' ? customUTC?.value : rigUTC;
  }, [timeZone, customUTC, rigUTC]);

  const timezoneOffsetString = useMemo(() => {
    return moment.tz(selectedTimeZone).format('Z');
  }, [selectedTimeZone]);

  const calculateDates = useCallback(
    ({startDate, endDate, useLocalTime = false, timezone = undefined}) => {
      if (!startDate || !endDate) return { dateStart: null, dateEnd: null };
      let tz = useLocalTime ? rigUTC : selectedTimeZone;
      if (timezone) {
        tz = timezone;
      }

      const startZone = moment.tz(startDate, tz).startOf('day');
      const endZone = moment.tz(endDate, tz).endOf('day');
      const start = startZone.format(DATE_TIMEZONE_FORMAT);
      const end = endZone.format(DATE_TIMEZONE_FORMAT);
      return { dateStart: start, dateEnd: end };
    },
    [selectedTimeZone, rigUTC]
  );
  const calculateDatesWithPadding = useCallback(
    (start_date, end_date, start, end = null) => {
      let endValue = end;
      if (!endValue) {
        endValue = start;
      }

      const dateStart = moment
        .tz(start_date, selectedTimeZone)
        .startOf('day')
        .subtract(start.value, start.unit)
        .format(DATE_TIMEZONE_FORMAT);
      const dateEnd = moment
        .tz(end_date, selectedTimeZone)
        .endOf('day')
        .add(endValue.value, endValue.unit)
        .format(DATE_TIMEZONE_FORMAT);
      return { dateStart: dateStart, dateEnd: dateEnd };
    },
    [selectedTimeZone]
  );

  return { calculateDates, selectedTimeZone, calculateDatesWithPadding, timezoneOffsetString };
};
